import { watch, onUnmounted, type Ref } from 'vue'

let lockCount = 0

function lock() {
  lockCount++
  if (lockCount === 1) {
    document.documentElement.style.overflow = 'hidden'
  }
}

function unlock() {
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount === 0) {
    document.documentElement.style.overflow = ''
  }
}

/**
 * Locks background page scroll while the given ref is truthy.
 * Uses a counter to support multiple concurrent overlays.
 */
export function useScrollLock(isOpen: Ref<boolean>) {
  const stop = watch(isOpen, (val) => {
    if (val) lock()
    else unlock()
  })

  onUnmounted(() => {
    if (isOpen.value) unlock()
    stop()
  })
}
